module.exports = __webpack_public_path__ + "static/media/matcon-logo1.2884d41f.png";